import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "panel", "toggle"]

  connect() {
    this.element.dataset.frequencyReady = "true"
  }

  disconnect() {
    delete this.element.dataset.frequencyReady
  }

  toggle() {
    const active = this.toggleTarget.checked
    this.panelTarget.hidden = !active

    const option = this.optionTargets.find(input => this.isNever(input) !== active)
    if (!option) return

    option.checked = true
  }

  isNever(input) {
    return input.dataset.key.toLowerCase() === "never"
  }
}
